import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import LocationReducer from "./location";
import WeatherReducer from "./weather";
import VariableReducer from './variables'

const rootReducer = combineReducers({
    weatherData: WeatherReducer,
    geoLocation: LocationReducer,
    variables: VariableReducer
})

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default function generateStore () {
    const store = createStore( rootReducer, composeEnhancers( applyMiddleware(thunk) ) )
    return store
}